import { ApplicationPageProps } from '../../Application';
import { ReferralSelection } from '../shared/ReferralSelection';

const F5_REFERRAL_OPTIONS = [
	{ text: 'Fellow F5er', textValue: 'Fellow F5er' },
	{ text: 'Your manager', textValue: 'Your manager' },
	{ text: 'F5 Global Good', textValue: 'F5 Global Good' },
	{ text: 'Radar/Sharepoint/Monday Minute', textValue: 'Radar/Sharepoint/Monday Minute' },
	{ text: 'Francois Locoh-Donou message', textValue: 'Francois Locoh-Donou message' },
	{ text: 'Other', textValue: 'Other' },
];

export const F5ReferralSelection = (props: ApplicationPageProps) => {

	return (
		<ReferralSelection
			{...props}
			referralOptions={F5_REFERRAL_OPTIONS}
			programTermsText="If accepted, I commit to volunteering up to 80 hours during my assigned Wave and will coordinate timing with my manager, who will be notified upon acceptance."
		/>
	);
};
